import React from 'react';
import "../../styles/search/search.css";
import { useEffect, useState } from "react";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { useSearchContext } from "../chats/searchContext";

import searchIcon from "../../images/chats/search_icon.png";
import fromImage from "../../images/authentication/no_profile.png";

const Search = () => {
    const {setUserId} = useSearchContext();
    const [getIsLoading, setIsLoading] = useState(true);
    const [getSearch, setSearch] = useState("");
    const [getYourUserId, setYourUserId] = useState("");
    const [getUserList, setUserList] = useState([]);
    const [getOriginalUserList, setOriginalUserList] = useState([]);

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const getAllUsers = async () => {
        let uList = [];
        try {
            const allUsersRef = collection(firebaseFirestore, 'User Details'); 
            const allUsersSnapshot = await getDocs(allUsersRef);
            
            allUsersSnapshot.forEach((userDoc) => {
                const userDetails = [
                    userDoc.id,
                    userDoc.data().username,
                    userDoc.data().image ?? "",
                ];

                const userExists = uList.some(user => user[0] === userDoc.id);
                if (!userExists) {
                    uList.push(userDetails);
                }
            });
            setUserList(uList);
            setOriginalUserList(uList);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log(`Error getting all usersP: ${error.message}`);
        }
    };

    const filterUsers = () => {
        if (getSearch === "") {
            setUserList(getOriginalUserList);
        } else {
            const filteredUsers = getOriginalUserList.filter((user) =>
                user[1].toLowerCase().includes(getSearch.toLowerCase())
            );
            setUserList(filteredUsers);
        }
    };

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
          if (user) {
            setYourUserId(user.uid);
          }
        });
    
        return () => isLoggedIn();
    }, []);

    useEffect(() => {
        filterUsers();
    }, [getOriginalUserList, getSearch])

    useEffect(() => {
        getAllUsers();
    }, [getYourUserId])

    return(
        <div className="search_screen">
            <div className="search_screen_search_input_container_i">
                <div className="search_screen_search_input_container">
                    <img src={searchIcon} className="search_screen_search_input_icon"/>
                    <input className="search_screen_search_input_field" id="item_section_search" placeholder={`Search for any user`} type="text" value={getSearch} onChange={onChangeSearch} />
                </div>
            </div>
            <div className="home_item_section_divider"></div>
            <div className="search_screen_block">
                {
                    getUserList.length > 0
                    ? getUserList.map((user, index) => (
                        <div key={index} className="search_screen_block_tab">
                            <div className="search_screen_block_tab_con">
                                <img className="search_screen_block_tab_image" src={user[2] === "" || user[2] === null ? fromImage : user[2]} />
                                <p className="search_screen_block_tab_name">@{user[1]}</p>
                            </div>

                            <Link className="search_screen_link" 
                                to={
                                        user[1] === "" || user[1] === null 
                                        ? null 
                                        : user[0] !== getYourUserId
                                        ? `/main_back/search/${user[1].toLowerCase()}/profile`
                                        : `/main_back/profile`
                                    }
                            >
                                <p className="search_screen_block_tab_view" onClick={() => setUserId(user[0])}>view</p>
                            </Link>
                        </div>
                    ))
                    : getIsLoading
                    ? <p className="search_screen_block_tab_p">Loading...</p>
                    : <p className="search_screen_block_tab_p">{getSearch === "" ? "Unable to load users 🥲" : `User ${getSearch} not found...`}</p>
                }
            </div>            
        </div>
    );
};

export default Search;